const log2x = require("./img/log2x.png");
console.log("log2x", log2x);

const imgs = {
  log2x,
};

export const getImg = function (imgName) {
  return imgs[imgName].default;
};
